import React from "react";

import "../style/reset.css"
import "../style/typography.css"

import SEO from "../components/seo";
import {ThemeProvider} from "styled-components";
import {useThemes} from "../style/themes.hook";
import {CookiesProvider} from "react-cookie";
import Header from "../components/header/header";
import {
  FullWidthContainer,
  Heading1,
  MaxWidthContainer
} from "../style/itf-styled-components";
import {useWorkshops} from "../data/hooks/workshops";
import WorkshopsList from "../components/workshops-list";
import Footer from "../components/footer";
import CookiesConsent from "../components/cookies-consent";

const Workshops = () => {
  const themes = useThemes();

  return (
    <>
      <CookiesProvider>
        <SEO
          title={`Workshopuri - Imagine Timisoara Festival 2021`}
          description={`Imagine Timisoara Festival, ajuns la cea de-a treia ediție, este un proiect al Asociației Imagine Timisoara.`}
        />
      </CookiesProvider>

      <ThemeProvider theme={themes.light}>
        <Header page="workshops"/>

        <FullWidthContainer>
            <MaxWidthContainer css={`padding: 50px 25px;`}>
              <Heading1>Workshopuri</Heading1>
              <WorkshopsList workshops={useWorkshops()}/>
            </MaxWidthContainer>
        </FullWidthContainer>
        <Footer/>

        <CookiesProvider>
          <CookiesConsent/>
        </CookiesProvider>
      </ThemeProvider>
    </>
  );
};

export default Workshops
